<template>
    <div>
		<ul class="nav nav-tabs details-tabs" role="tablist">
		    <li role="presentation" class="active">
		        <a href="#overview" aria-controls="home" role="tab" data-toggle="tab">产品概述</a>
		    </li>
		    <li role="presentation">
		        <a href="#specification" aria-controls="home" role="tab" data-toggle="tab">产品规格</a>
		    </li>
		</ul>
		<div class="tab-content">
			<div role="tabpanel" class="tab-pane active" id="overview">
				<img src="../assets/img/detail/fcw/1.jpg" width="100%" />
				<img src="../assets/img/detail/fcw/2.jpg" width="100%"/>
				<img src="../assets/img/detail/fcw/3.jpg" width="100%"/>
				<img src="../assets/img/detail/fcw/4.jpg" width="100%"/>
				<img src="../assets/img/detail/fcw/5.jpg" width="100%"/>
				<img src="../assets/img/detail/fcw/6.jpg" width="100%"/>
				<img src="../assets/img/detail/fcw/7.jpg" width="100%"/>
				<img src="../assets/img/detail/fcw/8.jpg" width="100%"/>
				<img src="../assets/img/detail/fcw/9.jpg" width="100%"/>
				<img src="../assets/img/detail/fcw/10.jpg" width="100%"/>
				<img src="../assets/img/detail/fcw/11.jpg" width="100%"/>
			</div>
			<div role="tabpanel" class="tab-pane active" id="specification">
				<div class="row">
				    <div class="col-md-4">
				        <div class="pic-box">
				            <img src="../assets/img/rdw-1.jpg"/>
				        </div>
				    </div>
				    <div class="col-md-8">
				        <div class="box-details">
				            <p><strong>特点：</strong>本产品采用优质，高强度不锈钢线材制作，设备先进，生产工艺清湛，具有网面光洁，硬度高，不断网，不变形，耐高温，耐腐蚀，走网灵活等优点，具有卓越的过滤性能。</p>
							<p><strong>用途：</strong>适用于塑料拉丝机、流延膜机、涂膜机的过滤，例如塑料编织袋、塑料薄膜等。</p>
							<p><strong>材质：</strong>选用优质不锈钢丝</p>
							<p><strong>编织方式：</strong>反差编织</p>
							<p><strong>规格：</strong>一般长度为10米长，宽度40mm-210mm,目数40目-350目，最宽可达50公分，特殊规格可加工定制。</p>
				        </div>
				    </div>
				
				</div>
				<div class="row rdw-pic">
				    <div class="col-md-4">
				        <div class="pic-box">
				            <img src="../assets/img/rdw-2.jpg"/>
				        </div>
				    </div>
				    <div class="col-md-4">
				        <div class="pic-box">
				            <img src="../assets/img/rdw-3.jpg"/>
				        </div>
				    </div>
				    <div class="col-md-4">
				        <div class="pic-box">
				            <img src="../assets/img/rdw-4.jpg"/>
				        </div>
				    </div>
				</div>
				<div class="row">
				    <div class="col-md-6">
				        <table class="table table-style table-bordered" cellspacing="" cellpadding="">
				            <thead>
				            <tr>
				                <th rowspan="2">目数</th>
				                <th colspan="2">丝径（mm）</th>
				            </tr>
				            <tr>
				                <th>经</th>
				                <th>纬</th>
				            </tr>
				            </thead>
				            <tbody>
				            <tr>
				                <td>72 x 15</td>
				                <td>0.450</td>
				                <td>0.450</td>
				            </tr>
				            <tr>
				                <td>120 x 15</td>
				                <td>0.350</td>
				                <td>0.500</td>
				            </tr>
				            <tr>
				                <td>130 x 30-35</td>
				                <td>0.200</td>
				                <td>0.200</td>
				            </tr>
				            <tr>
				                <td>132 x 17</td>
				                <td>0.320</td>
				                <td>0.320</td>
				            </tr>
				            <tr>
				                <td>150 x 18</td>
				                <td>0.300</td>
				                <td>0.300</td>
				            </tr>
				            <tr>
				                <td>152 x 24</td>
				                <td>0.280</td>
				                <td>0.280</td>
				            </tr>
				            <tr>
				                <td>160 x 18</td>
				                <td>0.270</td>
				                <td>0.270</td>
				            </tr>
				            <tr>
				                <td>175 x 40-50</td>
				                <td>0.150</td>
				                <td>0.150</td>
				            </tr>
				            <tr>
				                <td>180 x 18</td>
				                <td>0.260</td>
				                <td>0.260</td>
				            </tr>
				            </tbody>
				        </table>
				    </div>
				    <div class="col-md-6">
				        <table class="table table-style table-bordered" cellspacing="" cellpadding="">
				            <thead>
				            <tr>
				                <th rowspan="2">目数</th>
				                <th colspan="2">丝径（mm）</th>
				            </tr>
				            <tr>
				                <th>经</th>
				                <th>纬</th>
				            </tr>
				            </thead>
				            <tbody>
				            <tr>
				                <td>200 x 40</td>
				                <td>0.170</td>
				                <td>0.170</td>
				            </tr>
				            <tr>
				                <td>260 x 40</td>
				                <td>0.150</td>
				                <td>0.150</td>
				            </tr>
				            <tr>
				                <td>280 x 60-70</td>
				                <td>0.090</td>
				                <td>0.090</td>
				            </tr>
				            <tr>
				                <td>300 x 40</td>
				                <td>0.140</td>
				                <td>0.140</td>
				            </tr>
				            <tr>
				                <td>325 x 38</td>
				                <td>0.130</td>
				                <td>0.130</td>
				            </tr>
				            <tr>
				                <td>600 x 100-105</td>
				                <td>0.042</td>
				                <td>0.042</td>
				            </tr>
				            <tr>
				                <td>630 x 125-130</td>
				                <td>0.042</td>
				                <td>0.042</td>
				            </tr>
				            <tr>
				                <td>720 x 140-150</td>
				                <td>0.035</td>
				                <td>0.035</td>
				            </tr>
				            </tbody>
				        </table>
				    </div>
				</div>
			</div>
		</div>
		
    </div>
</template>

<script>
    export default {
        name: 'Product_sswm',
        data: function () {
            return {
            }
        },
        mounted: function () {

        },
        created: function () {

        },
        methods: {

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>